import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ActivateEmergencyCard from "./ActivateEmergencyCard";
import Layout from "@/components/Layout/Layout";
import { setNavigationSource } from "@/utils/navigationSource";
import { getMemberInfo } from "@/hooks/useMembers";

const EC_BACK_URL_KEY = "ec_back_url";

const ActivateEmergencyCardWrapper: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const memberInfo = getMemberInfo();

  // Set navigation source when page loads so modules navigate back here
  useEffect(() => {
    setNavigationSource("overview", window.location.pathname);
  }, []);

  // Persist backUrl from state into sessionStorage so it survives sub-page navigation
  useEffect(() => {
    const backUrl = (location.state as any)?.backUrl;
    if (backUrl) {
      sessionStorage.setItem(EC_BACK_URL_KEY, backUrl);
    }
  }, [location.state]);

  const handleBack = () => {
    const backUrl =
      sessionStorage.getItem(EC_BACK_URL_KEY) ||
      (location.state as any)?.backUrl;
    sessionStorage.removeItem(EC_BACK_URL_KEY);

    if (backUrl) {
      navigate(backUrl);
    } else {
      const memberId = (location.state as any)?.memberId || memberInfo.id;
      navigate(`/profile/family/member/${memberId}`);
    }
  };

  const fromProfileNav =
    (location.state as any)?.backUrl === '/profile' ||
    sessionStorage.getItem(EC_BACK_URL_KEY) === '/profile';

  return (
    <Layout hideExit hideBack showGradient hideProfilePicker hideFooterNav>
      <ActivateEmergencyCard onBack={handleBack} hideProfilePicker={fromProfileNav} />
    </Layout>
  );
};

export default ActivateEmergencyCardWrapper;
